/* eslint-disable */
import React, { useState, useCallback } from "react";
import Container from "../UI/Container";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import SwitchPro from "../UI/switchPro";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import MaterialRlsPdf from "./MaterialReleasePdf";
import { useReactToPrint } from "react-to-print";
import MaterialPropertiesModal from "../UI/MaterialProperties";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import { formattedDate } from "../../util";

import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
var pixelWidth = require('string-pixel-width');
import {
  Button,
  Stack,
  Autocomplete,
  TextField,
  Menu,
  MenuItem,
  Box,
  Grid,
} from "@mui/material";
import { useGlobalDataContext } from "../../Context/AppGlobalData";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import axios from "../../api";
import { getUniqueList } from "../../util";
import ShippingInstructionModal from "../UI/ShippingInstruction";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ReleaseForShipmentModal from "../UI/ReleaseForShipment";
import MendetoryIcon from "../UI/mendetoryicon";
import { usePopUpContext } from "../../Context/PopupMessage";
import { maxColumnWidth } from "../../util";
import { useMaterialPropertiesContext } from "../../Context/MaterialPropertiesContext";
function BrowseContainer(props) {
  const usertype =localStorage.getItem("type")
  let detaildata =JSON.parse(localStorage.getItem("detail"))
  React.useEffect(() => {
   if(usertype && usertype==="E"){
  
   
    setMillValue({keyStr:detaildata.cusNo,dispStr:detaildata.cusNm})
   }
   if(detaildata?.dsblBrh===1){
    setInventoryAtValue({keyStr:detaildata.brh,dispStr:detaildata.brhNm})
   }
  
  }, []);
  const {inventoryAtValue,millValue, setMillValue, setInventoryAtValue , shipmentReleaseDate, shipmentReleaseWeighht,shipmentInstruction, setShipmentInstruction } =
  useGlobalDataContext();
  const [pdfFilter, setPdfFilter] = useState([])
  const [openPdf, setOpenPdf] = useState(null)
  const [selectedRow, setSelectedRow] = useState();
  const [printData, setPrintData] = useState([]);
  const [pdfData, setPdfData] = useState([]);
  
  const [openReleaseForShipmentModal, setOpenReleaseForShipmentModal] =
    useState(false);
  const hideReleaseForShipmentModal = () => {
    setOpenReleaseForShipmentModal(false);
  
  };
  const saveReleaseShipmentDate = () => {
  let flag =prsMdValue?.dispStr !== "Tag" && !shipmentReleaseWeighht?false:true

    if(shipmentReleaseDate&&flag){
      setOpenReleaseForShipmentModal(false);
     
      let obj
      let tempShipmentDetailValue = rows.map((item) => {
        
     let k = {
        cusPoNo: item.cusPoNo,
        cusTagNo: item.cusTagNo,
        eusrPoNo: item.eusrPoNo,
        gaStr: item.gaStr,
        lgthStr: item.lgthStr,
        partNo: item.partNo,
        pcsStr: item.pcsStr,
        pcs: item.pcs,
        procrCoilStf: item.procrCoilStf,
        procrOrdStr: item.procrOrdStr,
        tagCtlNo: item.tagCtlNo,
        wdthStr: item.wdthStr,
        wgtStr: item.wgtStr,
        wgt:item.wgt,
        procrTagNo:item.procrTagNo
    ,
        release_date:
          item.tagCtlNo === selectedRow.tagCtlNo? formattedDate(shipmentReleaseDate,"MM-DD-YYYY HH:mm ") : item.release_date,
          release_weight:item.tagCtlNo === selectedRow.tagCtlNo? shipmentReleaseWeighht : item.release_weight,
    
      }
      if( item.tagCtlNo === selectedRow.tagCtlNo){
        obj =k
      }
      return k
 
    });
    let obj1
      obj1= [...printData,obj]
     
    setPrintData(obj1)
         setRows(tempShipmentDetailValue);
    }else{
      setPopupMessage({ state: true, type: "error", message: "Mandatory field required" })
    }
   
  };
  const [openMaterialPropertiesModal, setOpenMaterialPropertiesModal] =
    useState(false);
  const { setTagCtlNoValue,setPrsMdValue } = useMaterialPropertiesContext();
  const { setPopupMessage, setLoading } = usePopUpContext();
  const handleCellClick = (params) => {
    if (params.field === "calendar_icon") {
      // setSelectedCellParams(true);
      console.log(params.row);
      setOpenReleaseForShipmentModal(true);
      setSelectedRow(params.row);
    }
    if (params.field === "procrCoilStf") {
      if (params.row.isTot !== 1 ) {
        setOpenMaterialPropertiesModal(true);
        setTagCtlNoValue(params.row.tagCtlNo);
      
        setPrsMdValue({  
          useMetUnt: checked?1:0,
          prsMd: "I",
          tagCtlNo: params.row.tagCtlNo});
      }

    }
  };


  const apiRef = useGridApiRef();
  const [rows, setRows] = useState([]);
  const [assetColumns] = useState([  
    {
      field: "calendar_icon",
      headerName: "",
      renderCell: () => (
        <CalendarMonthIcon sx={{ height: "30px", color: "#6D92A5" }} />
      ),
      align: "center",
      sortable: false,
      width: 80,
    }, {
      field: "partNo",
      headerName: "Part No",
      sortable: false,
      width: 150,
    },
    {
      field: "cusPoNo",
      headerName: "Mill Order No",
      sortable: false,
      width: 160,
    },
    {hide: false,
      field: "eusrPoNo",
      headerName: "End-User PO",
      sortable: false,
      width: 160,
    },
    {hide: false,
      field: "cusTagNo",
      headerName: "Mill Coil ID",
      sortable: false,
      width: 160,
    },
    {
      field: "procrOrdStr",
      headerName: "Processor Order No",
      type: 'number',
      sortable: false,
      width: 180,
    },
    {hide: false,
      field: "procrCoilStf",
      headerName: "Processor Coil ID",
      renderCell: (params) => (
        <div
          dangerouslySetInnerHTML={{
            __html: params.value,
          }}
        />
      ),
      sortable: false,
      width: 180,
    },
    {
      field: "gaStr",
      headerName: "Gauge",
      sortable: false,
      width: 100,
    },
    {
      field: "wdthStr",
      headerName: "Width",
      sortable: false,
      width: 100,
      type: 'number',
    },
    {
      field: "lgthStr",
      headerName: "Length",
      sortable: false,
      width: 100,
      type: 'number',
    },
    {
      field: "wgtStr",
      headerName: "LBS",
      sortable: false,
      width: 100,
      type: 'number',
    },
    {
      field: "pcsStr",
      headerName: "Pieces",
      sortable: false,
      width: 100,
      type: 'number',
    },
    {
      field: "release_date",
      headerName: "Date/Time",
      type: "dateTime",
      editable: false,
      sortable: false,
      width: 180,
    },
   { hide: true,

    field: "release_weight",
    headerName: "Release Weight",
    type: "dateTime",
    editable: false,
    sortable: false,
    width: 175}
   
  ]);
  const [byweightColumns] = useState([  
    {
      field: "calendar_icon",
      headerName: "",
      renderCell: () => (
        <CalendarMonthIcon sx={{ height: "30px", color: "#6D92A5" }} />
      ),
      align: "center",
      sortable: false,
      width: 80,
    }, {
      field: "partNo",
      headerName: "Part No",
      sortable: false,
      width: 150,
    },
    {
      field: "cusPoNo",
      headerName: "Mill Order No",
      sortable: false,
      width: 160,
    },
    {hide: true,
      field: "eusrPoNo",
      headerName: "End-User PO",
      sortable: false,
      width: 160,
    },
    {hide: true,
      field: "cusTagNo",
      headerName: "Mill Coil ID",
      sortable: false,
      width: 160,
    },
    {
      field: "procrOrdStr",
      headerName: "Processor Order No",
      type: 'number',
      sortable: false,
      width: 180,
    },
    {hide: true,
      field: "procrCoilStf",
      headerName: "Processor Coil ID",
      renderCell: (params) => (
        <div
          dangerouslySetInnerHTML={{
            __html: params.value,
          }}
        />
      ),
      sortable: false,
      width: 180,
    },
    {
      field: "gaStr",
      headerName: "Gauge",
      sortable: false,
      width: 100,
    },
    {
      field: "wdthStr",
      headerName: "Width",
      sortable: false,
      width: 100,
      type: 'number',
    },
    {
      field: "lgthStr",
      headerName: "Length",
      sortable: false,
      width: 100,
      type: 'number',
    },
    {
      field: "wgtStr",
      headerName: "LBS",
      sortable: false,
      width: 100,
      type: 'number',
    },
    {
      field: "pcsStr",
      headerName: "Pieces",
      sortable: false,
      width: 100,
      type: 'number',
    },
    {
      field: "release_date",
      headerName: "Date/Time",
      type: "dateTime",
      editable: false,
      sortable: false,
      width: 180,
    },
   { hide: true,

    field: "release_weight",
    headerName: "Release Weight",
    type: "dateTime",
    editable: false,
    sortable: false,
    width: 175}
  ]);
  const [prsMdValue, setRelease] = useState({ dispStr: "Tag", keyStr: "T" });

  const [openInventoryAt, setOpenInventoryAt] = useState(false);
  const [inventoryAtOption, setInventoryAtOption] = useState([]);

  const [openMill, setOpenMill] = useState(false);
  const [millOption, setMillOption] = useState([]);


  const [millOrderNoValue, setMillOrderNoValue] = useState(null);

  const [openEndUser, setOpenEndUser] = useState(false);
  const [endUserOption, setEndUserOption] = useState([]);
  const [endUserValue, setEndUserValue] = useState(null);

  const [endUserPOValue, setEndUserPOValue] = useState(null);


  const [openPartNo, setOpenPartNo] = useState(false);
  const [partNoOption, setPartNoOption] = useState([]);
  const [partNoValue, setPartNoValue] = useState(null);
  const [partNoInputValue, setPartNoInputValue] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [checked, setChecked] = useState(false);
  const [openShippingInstructionModal, setOpenShippingInstructionModal] =
    useState(false);




  const handleMore = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setLoading(false)
    setOpenPdf(false)
 
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const getValue = (params, setValue, setOpen) => {
    setLoading(true)
   
    let url = "/lookupsvc";
    let headers = {
      "invera-service-name": "scbesbv",
    };
    axios
      .post(url, params, headers)
      .then((res) => {
        setLoading(false)
        setOpen(true);
        var arrResponse = res.data.output.fldTbl;
        setValue(arrResponse);
        if(res.data.output.rtnSts===2){
          setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
        }
       
      })
      .catch((e) => {
        console.log(e);
        setOpen(false);
        setLoading(false)
        setPopupMessage({ state: true, type: "error", message: e.response.data?.Message })
       });
  };
  const clearShipmentHandler = () => {
    let tempShipmentDetailValue = rows.map((item) => ({
      cusPoNo: item.cusPoNo,
      cusTagNo: item.cusTagNo,
      eusrPoNo: item.eusrPoNo,
      gaStr: item.gaStr,
      lgthStr: item.lgthStr,
      partNo: item.partNo,
      pcsStr: item.pcsStr,
      pcs: item.pcs,
      wgt:item.wgt,
      procrCoilStf: item.procrCoilStf,
      procrOrdStr: item.procrOrdStr,
      tagCtlNo: item.tagCtlNo,
      wdthStr: item.wdthStr,
      wgtStr: item.wgtStr,
      release_date: "",
      release_weight: "",
      procrTagNo:item.procrTagNo
    
    }));
    setPrintData([])
    setOpenPdf(false)
    setRows(tempShipmentDetailValue);
    setShipmentInstruction("");
  };

  const shippingInstructionHandler = () => {
    setOpenShippingInstructionModal(true);
  };
  const hideShippingInstructionModal = () => {
    setOpenShippingInstructionModal(false);
  };




  const toggleMetricUnits = useCallback(() => {
    setChecked((checked) => !checked);
  }, []);

  const release = [
    { dispStr: "Tag", keyStr: "T" },
    { dispStr: "Weight", keyStr: "W" },
  ];
  const handleGo = async (e,nextCall) => {
       e.preventDefault()
       setLoading(true)
    var postData = {
      prsMd: prsMdValue?.keyStr,
      brh: inventoryAtValue?.keyStr===""?"":inventoryAtValue?.keyStr,
      cusNo: millValue?.keyStr === ""?null : Number(millValue?.keyStr),
      // cusNo: 603,
      // frstTmFlg: nextCall,
    };
    console.log(inventoryAtValue)
    var filter = {
      "Ship from": inventoryAtValue?.dispStr,
      "Mill": millValue?.dispStr,

    }


    if (checked) {
      postData["useMetUnt"] = 1;
    } else {
      postData["useMetUnt"] = 0;
    }
    if (millOrderNoValue) {
      postData["cusPoNo"] = millOrderNoValue;
      filter["Mill Order No"] = millOrderNoValue;
    }

    if (endUserValue) {
      postData["eusrNo"] = Number(endUserValue.keyStr);
      filter["End-User"] = endUserValue.dispStr;
    }

    if (endUserPOValue) {
      postData["eusrPoNo"] = endUserPOValue;
      filter["End-User PO"] = endUserPOValue;
    }

   
    if (partNoValue) {
      postData["partNo"] = partNoValue.keyStr;
      filter["Part No"] = partNoValue.dispStr;
    } else if (partNoInputValue && partNoInputValue.trim() !== "") {
      postData["partNo"] = partNoInputValue.trim();
      filter["Part No"] = partNoInputValue.trim();
    }
    setShipmentInstruction("")
    setPdfFilter(filter)
    setPrintData([])
    const data = await getAll(postData)

    if(data.success){
      setLoading(false)
      setRows(data.rowsData);
      var updatedData
      updatedData =   assetColumns.map(x => (
        
        x.field === "wgtStr"?{ ...x,headerName:data.wgtUm, width: maxColumnWidth(x.field, data.rowsData) }:     
       
        x.field ==="release_weight"||x.field ==="procrOrdStr"||  x.field ==="procrCoilStf"||x.field ==="calendar_icon"||x.field ==="release_date" ? x: { ...x,  width: maxColumnWidth(x.field,data.rowsData) } ));
      
        let weightColumn
       
        if(prsMdValue?.dispStr !== "Tag"){
           updatedData = byweightColumns.map(
            
            x => (
              x.field === "wgtStr"?{ ...x,headerName:data.wgtUm, width: maxColumnWidth(x.field, data.rowsData) }:    
              x.field ==="release_weight"||x.field ==="procrOrdStr"||  x.field ==="procrCoilStf"||x.field ==="calendar_icon"||x.field ==="release_date" ? x: { ...x,  width: maxColumnWidth(x.field,data.rowsData) } ));

          weightColumn=   {
           
            hide: false,

            field: "release_weight",
            headerName: "Release Weight",
            type: "dateTime",
            editable: false,
            sortable: false,
            width: 140,
          }
        }else{
          weightColumn ={
           
            hide: true,

            field: "release_weight",
            headerName: "Release Weight",
            type: "dateTime",
            editable: false,
            sortable: false,
            width: 175,
          };
        }
        updatedData.push(weightColumn)
        console.log(updatedData)
      apiRef.current.updateColumns(updatedData)
      // setAssetColumns(updatedData)
    }

   };

   const getAll = async (postData)=>{
    setLoading(true)
    let flag =true;
    let nextRecord = null
     let frstTmFlg =1
     let rowsData = []
     let wgtUm ="LBS"
    while (flag) {
     
      if(nextRecord){
        postData["sTagCtlNo"] = nextRecord;
      }
        
        postData["frstTmFlg"] = frstTmFlg
   
   await axios
        .post("/matrelease", postData /*axiosConfig*/)
        .then((res) => {
        
             frstTmFlg=0
             rowsData = [...rowsData, ...res.data.output.fldTbl]
          if (res.data.output.eof === 0) {
            flag = true
            nextRecord = res.data.output.nTagCtlNo;     
          } else{
            flag = false
          }
          if(res.data.output.rtnSts===2){
            setPopupMessage({ state: true, type: "warning", message:res.data.output?.msg })
          }
          wgtUm = res.data.output.wgtUm
        })
        .catch((err) => {
          setLoading(false)
       
          flag = false
          setPopupMessage({ state: true, type: "error", message: err.response.data?.Message })
         let data = {success:false,rowsData:rowsData}
          return data
          // setRows([]);
        });
    }
    setwgtUm(wgtUm)
    setLoading(false)
    let data = {success:true,rowsData:rowsData,wgtUm:wgtUm}
    return data

  }

  const getMailDetail = async (pdfData)=>{
    setLoading(true)
  
    var postData = {
      prsMd: "G",
      cusNo: Number(millValue?.keyStr)
    };
   await axios
        .post("/matrelease", postData /*axiosConfig*/)
        .then((res) => {
         let output = res.data.output
         setLoading(false)
          let params={
            pdfData: pdfData,
            emailSubj: output.emailSubj,
            toEmail: output.toEmail,
            wrkgDir: output.wrkgDir
          }
           axios
             .post( "/materialsubmit", params)
             .then((res) => {
               setLoading(false)
               setPopupMessage({ state: true, type: "success", message: "Mail send ." })
            
             })
             .catch((e) => {
               console.log(e);
                setLoading(false)
             });
        })
        .catch((err) => {
          setLoading(false)
          
          setPopupMessage({ state: true, type: "error", message: err.response.data?.Message })
       
         
        });
    }






   const [typingTimer, setTypingTimer] = useState();
   const SearchServiceCall = (async (newValue, parms, setOption, setOpen) => {
    // setproductSearchTextField(newValue);

    clearTimeout(typingTimer);
    if (newValue) {
      setOption([])
      const typingTimer_ = setTimeout(async () => {
        setLoading(true)
        //console.log("service call-------------------------------------------------")
        getValue(parms, setOption, setOpen);
      }, 1000);
      setTypingTimer(typingTimer_);
    } else {
      getValue({ prsMd: parms.prsMd }, setOption, setOpen);
    }
  });
  const hideMaterialPropertiesModal = () => {
    setOpenMaterialPropertiesModal(false);
  };


  const componentRef = React.useRef();
  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const handleOnBeforeGetContent = React.useCallback(async () => {
    const k =  getUniqueList(printData,"tagCtlNo")
   console.log(printData)
    if(k.length===0){
      setPopupMessage({ state: true, type: "error", message: "Ship date/time is invalid" })
      handleClose()
    }else if(shipmentInstruction===null||shipmentInstruction===""){
      setPopupMessage({ state: true, type: "error", message: "You must specify shipping instruction" })
      handleClose()
    }else{
      return new Promise((resolve) => {
      setPdfData(k)
      console.log("promise")
      setOpenPdf(true)
      resolve();


  });
     
    }


   
  }, [[]]);
  const handlePrint2pdf = useReactToPrint({
    content: reactToPrintContent,
    onBeforeGetContent: handleOnBeforeGetContent,
    removeAfterPrint: true,
    // pageStyle:'@page { size: auto; margin: 0mm; } @media print { body { -webkit-print-color-adjust: exact;font-family: Courrier New, monospace; padding: 40px !important;font-size: 14px !important; } }',
    print: async (printIframe) => {
      // Instead of sending HTML, send structured data
      const k = getUniqueList(printData, "tagCtlNo");
      const pdfDataToSend = {
        data: k,
        by: prsMdValue?.keyStr || "T",
        wgtUm: wgtUm,
        filter: pdfFilter,
        shipmentInstruction: shipmentInstruction || ""
      };
      getMailDetail(pdfDataToSend);
    },
    documentTitle: `InventoryStatus_${new Date().toJSON().slice(0, 10)}`,
  
    // onAfterPrint: handleAfterPrint
  });
  const handleAfterPrint = React.useCallback(() => {
    setOpenPdf(false)
    handleClose()
  }, []);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: `InventoryStatus_${new Date().toJSON().slice(0, 10)}`,
    onBeforeGetContent: handleOnBeforeGetContent,
    removeAfterPrint: true,
  onAfterPrint: handleAfterPrint
  });

  const [wgtUm, setwgtUm] = useState("LBS")
  const addStyleToSheet = (workbookBlob, apiData) => {
    try {
      console.log("addStyleToSheet-----------------------")
        return XlsxPopulate.fromDataAsync(workbookBlob).then((workbook) => {
            workbook.sheets().forEach((sheet) => {
                // Get the used range of the sheet
                const usedRange = sheet.usedRange();
  
                // Set the first row background color to green up to the last column with data
                const lastColumnNumber = usedRange._maxColumnNumber;
                let lastColumnLetter;
                if (lastColumnNumber <= 26) {
                    lastColumnLetter = String.fromCharCode(64 + lastColumnNumber);
                } else {
                    const firstLetter = String.fromCharCode(64 + Math.floor((lastColumnNumber - 1) / 26));
                    const secondLetter = String.fromCharCode(64 + ((lastColumnNumber - 1) % 26) + 1);
                    lastColumnLetter = `${firstLetter}${secondLetter}`;
                }
                // sheet.range(`A1:${lastColumnLetter}1`).style({
                //     fill: {
                //         type: "solid",
                //         color: "#90EE90"
                //     },
                //     // fgColor: { argb: 'FF90EE90' }, // Green color
                //     // color: "#ffffff",
                // });
  
                // Set the width of each column based on its maximum width
                for (let colNumber = 1; colNumber <= lastColumnNumber; colNumber++) {
                    const columnLetter = String.fromCharCode(64 + colNumber);
                    const column = sheet.column(columnLetter);
  
                    // Get the maximum width of the column
                    let maxWidth = 0;
                    const rowCount = usedRange._numRows;
                    for (let row = 1; row <= rowCount; row++) {
                        const cell = column.cell(row);
                        const cellValue = cell._value !== undefined ? cell._value.toString() : ''; // Convert value to string
                        // const cellWidth = cellValue.length;
                        maxWidth = Math.max(maxWidth, pixelWidth(cellValue, { size: 2 }));
                     //   cell.value(cellValue); // Set the cell value as a string
                    }
  
                    // Set the width of the column
                    // column.autoSize();
                    // column.width(250); // Adjust the width as needed
                    column.width((maxWidth + 3) <= 100 ? maxWidth + 3 : 100); // Adjust the width as needed                     
                    column.style({ wrapText: true });
                    // Alternatively, you can set a specific width for all columns
                    // column.width(10); // Set a specific width for all columns
                }
  
            });
  
            return workbook.outputAsync().then((workbookBlob) => URL.createObjectURL(workbookBlob));
        }).catch((error) => {
            console.error("Error in addStyleToSheet", error);
            return XlsxPopulate.fromDataAsync(workbookBlob).then((workbook) => {
                return workbook.outputAsync().then((workbookBlob) => URL.createObjectURL(workbookBlob));
            })
        });
    }
    catch (err) {
        console.error("Error in addStyleToSheet", err);
        return XlsxPopulate.fromDataAsync(workbookBlob).then((workbook) => {
            return workbook.outputAsync().then((workbookBlob) => URL.createObjectURL(workbookBlob));
        })
    }
  };
//---------------------------------------- xls------------------------------------------
const exportToXls = async () => {
  setLoading(true)
  const apiData =  getUniqueList(printData,"tagCtlNo")
   
    if(apiData.length===0){
      setPopupMessage({ state: true, type: "error", message: "Ship date/time is invalid" })
      handleClose()
    }else if(shipmentInstruction==null||shipmentInstruction==""){
      setPopupMessage({ state: true, type: "error", message: "You must specify shipping instruction" })
      handleClose()
    }else{


      apiData["release_date"] =   formattedDate(apiData["release_date"],"MM-DD-YYYY HH:mm ")
  //  console.log(apiData)

  let fileName =`Material_release${Date.now()}`
  let keyMap = {
    partNo: "Part No",
    cusPoNo: "Mill Order No",
    ...(prsMdValue?.dispStr === "Tag") && {
    eusrPoNo: "End-User PO",
   cusTagNo: "Mill Coil ID"
   
  }
  , procrOrdStr:"Processor Order No",
  ...(prsMdValue?.dispStr === "Tag") && { procrTagNo: "Processor Coil ID"},
    gaStr: "Gauge",
    wdthStr: "Width",
    lgthStr: "Length",
    wgt: wgtUm,
    pcs: "Pieces",

    ...(prsMdValue?.dispStr !== "Tag") && {release_weight: "Shipment"+ wgtUm},
    release_date: "Date/Time",
  };

  let pdfFilterString = new Date().toDateString() + '\n' + 'Material Release'  + '\n\n' +  'Criteria : \n';

  for (const key in pdfFilter) {
    if (pdfFilter.hasOwnProperty(key)) {
      pdfFilterString += key + ': ' + pdfFilter[key] + '\n';
    }
  
  }
  pdfFilterString +=  '\n' + 'Shipping Instruction : ' + shipmentInstruction  + '\n';
  
  
  // Convert the additional information into an array of lines
  const additionalInfoLines = pdfFilterString.split('\n').map(line => [line]);
  
  let newData = additionalInfoLines; // Start with the additional info
  
  // Include the header row based on keyMap
  const headerRow = Object.values(keyMap);
  newData.push(headerRow);
  
  // Map the API data to the desired format
  apiData.forEach((rec) => {
    let mappedData = Object.keys(keyMap).reduce((obj, k) => {
      if (k === "Date/Time") {
        obj[keyMap[k]] = formattedDate(rec[k], "MM-DD-YYYY HH:mm ");
      } else {
        obj[keyMap[k]] = rec[k];
      }
      return obj;
    }, {});
    newData.push(Object.values(mappedData));
  });
  
  const wsData = XLSX.utils.aoa_to_sheet(newData);
  
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const wb = { Sheets: { data: wsData }, SheetNames: ["data"] };
  const excelBuffer = await XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });

  addStyleToSheet(data, newData).then((url) => {
    FileSaver.saveAs(url, fileName + ".xlsx");
  })
  
  
   handleClose()
     
    }
    




  

};


//---------------------------------------- xls------------------------------------------

const clear = () => {
  
  setMillOrderNoValue(null)
setEndUserValue(null);  
setPartNoValue(null)
setPartNoInputValue("")
setEndUserPOValue(null)
setChecked(false)



 
}
  
  return (
    <>
     {openMaterialPropertiesModal ? (
        <MaterialPropertiesModal
          open={true}
          onClose={hideMaterialPropertiesModal}
        />
      ) : null}
     
      <ShippingInstructionModal
        open={openShippingInstructionModal}
        onClose={hideShippingInstructionModal}
      />
      <ReleaseForShipmentModal
      wgtUm={wgtUm}
        open={openReleaseForShipmentModal}
        onClose={hideReleaseForShipmentModal}
        onSave={saveReleaseShipmentDate}
        date={selectedRow?.release_date?selectedRow.release_date:new Date}
        weight={ prsMdValue?.dispStr!=="Tag"? selectedRow?.wgt:null}
        shipweight={ prsMdValue?.dispStr!=="Tag"? selectedRow?.release_weight:null}
        shipweightstr={ prsMdValue?.dispStr!=="Tag"? selectedRow?.wgtStr:null}
      />
      <Container
        sx={{
          overFlow: "auto",
          display: "flex",
          flex: 1,
          flexDirection: "column",
        }}
      >
        {/* Filter */}
          <Container className="ixFilterContainer" sx={{ height: "auto" }}>
            {/* Displays Filter */}
            <form onSubmit={(e) => handleGo(e,1)}>
              <Stack direction="row" spacing={5}>
                <Grid container sx={{ width: "80%" }} spacing={2} direction="row">
                  <Grid item xs={1} textAlign="end">Inventory At  <MendetoryIcon/></Grid>
                  <Grid item xs={3}><Autocomplete
                   noOptionsText="No items found"
                    open={openInventoryAt}
                    onOpen={() => {
                      getValue(
                        { prsMd: "B" },
                        setInventoryAtOption,
                        setOpenInventoryAt
                      );
                    }}
                    disabled={detaildata?.dsblBrh===1?true:false}
                    onClose={() => {
                      setOpenInventoryAt(false);
                    }}
                    value={inventoryAtValue?{dispStr:inventoryAtValue.dispStr}:null}
                    options={inventoryAtOption}
                    isOptionEqualToValue={(option, value) =>
                      option.dispStr === value.dispStr
                    }
                    getOptionLabel={(option) => option.dispStr}
                    onChange={(event, newValue) => {
                      setRows([]);
                      setInventoryAtValue(newValue ? newValue : "")

                    }}
                    renderInput={(params) => <TextField      value={inventoryAtValue?{dispStr:inventoryAtValue.dispStr}:null} 
                    onChange={(e)=>{SearchServiceCall(e.target.value, { prsMd: "B" ,srchStr:e.target.value}, setInventoryAtOption,
                    setOpenInventoryAt)
                    setInventoryAtValue({ "keyStr": "",
                    "dispStr": e.target.value});
                  
                  }
                  
                  
                  }{...params}   />}
                     />
                  </Grid>
                  {usertype==="I" ? <>  <Grid item xs={1} textAlign="end">Mill  <MendetoryIcon/></Grid>
                  <Grid item xs={3}>
                  <Autocomplete
                   noOptionsText="No items found"
                    open={openMill}
                    onOpen={() => {
                      getValue({ prsMd: "M" }, setMillOption, setOpenMill);
                    }}
                    onClose={() => {
                      setOpenMill(false);
                    }}
                    value={millValue?{dispStr:millValue.dispStr}:null}
                    options={millOption}
                    isOptionEqualToValue={(option, value) =>
                      option.dispStr === value.dispStr
                    }
                    getOptionLabel={(option) => option.dispStr}
                    
                    onChange={(event, newValue) => {         
                      setRows([]);
                      setMillValue(newValue?newValue:0);
                      setEndUserValue(null);
                      setPartNoValue(null)
                      setPartNoInputValue("")
                    
                  }}
                    
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        value={millValue?{dispStr:millValue.dispStr}:null}
                        onChange={(e)=>{SearchServiceCall(e.target.value, {prsMd: "M" ,srchStr:e.target.value}, setMillOption,
                  setOpenMill)
                  setMillValue({ "keyStr": "",
                          "dispStr": e.target.value});
                        
                        
                }} 
                      />
                    )}
                  />
                </Grid></>:null}
                  <Grid item xs={1} textAlign="end">Mill Order No</Grid>
                  <Grid item xs={3} >
                  <Stack spacing={4} direction="row">
                    <TextField 
                      onChange={(e) => {setMillOrderNoValue(e.target.value)
                           setRows([]);
                           }}
                           value={millOrderNoValue || ""}
                           />
                          
                          
                          {usertype ==="I" ?    <Stack direction="row" spacing={1}><Button
                          
                          type="submit"
                          styletype="icon" >
                          <PlayArrowIcon />
                        </Button> 
                           <Button
                           sx={{width:100}}
                       onClick={clear}
                       // sx={{ margin: "3px" }}
                       >
                     clear
                 </Button> </Stack>
                     :null}
                        </Stack>
                  </Grid>
                  <Grid item xs={1} textAlign="end">End-User</Grid>
                  <Grid item xs={3}>
                  <Stack spacing={4} direction="row">
                  <Autocomplete
                   noOptionsText="No items found"
                   sx={{width:250}}
                    open={openEndUser}
                    onOpen={() => {
                      getValue(
                        { prsMd: "E",fltrStr: millValue?.keyStr? `${millValue?.keyStr}`  :""},
                        setEndUserOption,
                        setOpenEndUser
                      );
                    }}
                    onClose={() => {
                      setOpenEndUser(false);
                    }}
                    value={endUserValue?{dispStr:endUserValue.dispStr}:null}
                    options={endUserOption}
                    isOptionEqualToValue={(option, value) =>
                      option.dispStr === value.dispStr
                    }
                    getOptionLabel={(option) => option.dispStr}
                    // onInputChange={(option, value) => onChangeTableSelect(option, value, setNameValue)}

                    onChange={(event, newValue) => {
                      setRows([]);
            
                      setEndUserValue(newValue?newValue:null);
                    
                      setPartNoValue(null)
                      setPartNoInputValue("")
                      // console.log(newValue.keyStr);
                    
                  }}
                  renderInput={(params) => <TextField  onChange={(e)=>SearchServiceCall(e.target.value, {prsMd: "E",fltrStr: millValue.keyStr ,srchStr:e.target.value}, setEndUserOption,
                  setOpenEndUser)}{...params}   />}
                  />
                   
                   {usertype !== "I" ?   <Stack direction="row" spacing={1}> <Button
                          
                          type="submit"
                          styletype="icon" >
                          <PlayArrowIcon />
                        </Button>
                         <Button
                         sx={{width:100}}
                     onClick={clear}
                     // sx={{ margin: "3px" }}
                     >
                   clear
               </Button>
                        </Stack>
                        :null}
                        </Stack>
                  </Grid>
                  <Grid item xs={1} textAlign="end">Part No </Grid>
                  <Grid item xs={3}>
                  <Autocomplete
                   noOptionsText="No items found"
                    freeSolo
                    forcePopupIcon
                    open={openPartNo}
                    value={partNoValue ? (typeof partNoValue === 'string' ? partNoValue : { dispStr: partNoValue.dispStr }) : null}
                    inputValue={partNoInputValue}
                    onInputChange={(event, newInputValue, reason) => {
                      setPartNoInputValue(newInputValue);
                      if (newInputValue && reason === 'input') {
                        setOpenPartNo(true);
                        SearchServiceCall(newInputValue, { prsMd: "P",fltrStr: `${millValue?.keyStr || ""}|${endUserValue?.keyStr || ""}`, srchStr: newInputValue }, setPartNoOption,
                          () => setOpenPartNo(true));
                      } else if (!newInputValue) {
                        setOpenPartNo(false);
                      }
                    }}
                    onOpen={() => {
                      setOpenPartNo(true);
                      if (!partNoInputValue) {
                        getValue({ prsMd: "P",fltrStr: `${ millValue.keyStr? millValue?.keyStr:""}|${ endUserValue?.keyStr?`${endUserValue?.keyStr}`:""}`}, setPartNoOption, setOpenPartNo);
                      }
                    }}
                    onClose={(event, reason) => {
                      if (reason === 'selectOption' || reason === 'blur' || reason === 'escape') {
                        setOpenPartNo(false);
                      }
                    }}
                    options={partNoOption}
                    isOptionEqualToValue={(option, value) =>
                      typeof value === 'string' ? option.dispStr === value : option.dispStr === value.dispStr
                    }
                    getOptionLabel={(option) => typeof option === 'string' ? option : option.dispStr}
                    onChange={(event, newValue) => {    
                      if (typeof newValue === 'string') {
                        setPartNoValue({ keyStr: newValue, dispStr: newValue });
                        setPartNoInputValue(newValue);
                      } else {
                        setPartNoValue(newValue ? newValue : null);
                        setPartNoInputValue(newValue ? newValue.dispStr : "");
                      }
                      setRows([]);
                    
                  }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                  </Grid>
                  <Grid item xs={1} textAlign="end">End-User PO</Grid>
                  <Grid item xs={3}>
                    <TextField
                      value={endUserPOValue || ""}
                      onChange={(e) => {setEndUserPOValue(e.target.value);
                        setRows([]);}}
                    />
                  </Grid>
                  <Grid item xs={1} textAlign="end">Release <MendetoryIcon/></Grid>
                  <Grid item xs={3}>
                    <Autocomplete
                     noOptionsText="No items found"
                      options={release}
                        sx={{width:150}}
                      isOptionEqualToValue={(option, value) =>
                        option.dispStr === value.dispStr
                      }
                      value={prsMdValue?{dispStr:prsMdValue.dispStr}:null}
                      getOptionLabel={(option) => option.dispStr}
                      onChange={(event, newValue) => {
                        setRows([]);    
                        setRelease(newValue?newValue:null);
                      
                      
                    }}             
                      
                     
                      
                      renderInput={(params) => (
                        <TextField
                          {...params} />
                      )} />
                  </Grid>
                  <Grid item xs={1} textAlign="end">Use Metric Units</Grid>
                  <Grid item xs={3}>
                    <SwitchPro
                      checked={checked}
                      onChange={(e) =>{toggleMetricUnits()
                        setRows([])}}
                      inputProps={{ 'aria-label': 'controlled' }} />
                  </Grid>
                </Grid>    
                 
                </Stack>
            </form>

          </Container>
       
        <div className="spacing"> </div>

        <Container
          className="ixBrowseGridLayout"
          sx={{ display: "flex", flexDirection: "column" }}
        >
          {rows.length>0?  <Container className="ixBrowseGridActionBar" sx={{ height: "50px " }}>
            <Stack
              className="ixBrowseGridActionBarContents"
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={0.5}
            >
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Button
                  onClick={clearShipmentHandler}
                >
                  Clear All Shipments
                </Button>
                <Button
                  onClick={shippingInstructionHandler}
                >
                  Shipping Instruction
                </Button>
                <Button
                  onClick={handlePrint2pdf}
                
                  sx={{
                    width: "auto",
                  }}
                >
                  Submit Material Release
                </Button>
                <Button styletype="icon" onClick={(e) => handleMore(e)}>
                  <MoreVertIcon />
                </Button>
              </Stack>
            </Stack>
            <Menu
              PaperProps={{
                className: "invPopupMenuVeryDark",
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
            >
              <MenuItem 
              onClick={handlePrint}
               >

Export to PDF</MenuItem>
<MenuItem onClick={exportToXls} > Export to XLS</MenuItem>
              <MenuItem>Help</MenuItem>
            </Menu>
          </Container>:null}
          <Container className="ixBrowseGridContainer">
            <DataGridPro
              headerHeight={40}
              columnBuffer={10}
              hideFooter={true}
              apiRef={apiRef}
              columns={assetColumns}
              rowHeight={30}
              disableColumnMenu={true}
              getRowId={(row) => row.tagCtlNo}
              rows={rows}
              onCellClick={handleCellClick}
            />
          </Container>
        </Container>
      </Container>
      {
        openPdf ?
          <Box style={{
            flex: 1,
            displayPrint: 'block',
          }}>
            <MaterialRlsPdf ref={componentRef} data={pdfData} wgtUm={wgtUm}by={prsMdValue.keyStr}filter={pdfFilter}  />
          </Box>
          : null
      }
    </>
  );
}
export default BrowseContainer;
